import type { GlowApiError, Teacher } from '@innovamat/glow-api-client';
import {
  useResendInvitationMutation,
  useResendSchoolInvitationMutation,
} from '@innovamat/glow-api-client';

type Props = {
  onSuccess?: () => void;
  onError?: (error: GlowApiError) => void;
};

type UseResendInvitation = {
  onResendInvitation: (teacher: Teacher) => void;
  isResendingInvitation: boolean;
};

function useResendInvitation({
  onSuccess,
  onError,
}: Props): UseResendInvitation {
  const {
    mutate: onResendSchoolInvitationMutation,
    isPending: isResendingSchoolInvitation,
  } = useResendSchoolInvitationMutation();
  const {
    mutate: onResendInvitationMutation,
    isPending: isResendingInvitation,
  } = useResendInvitationMutation();

  const onResendInvitation = (teacher: Teacher): void => {
    if (!teacher.token) return;

    const { id, token } = teacher;

    if (teacher.isSchoolInvitation) {
      onResendSchoolInvitationMutation(
        { body: { id, token } },
        {
          onSuccess: () => {
            onSuccess?.();
          },
          onError: (error) => {
            onError?.(error as GlowApiError);
          },
        }
      );
    } else {
      onResendInvitationMutation(
        { body: { id, token } },
        {
          onSuccess: () => {
            onSuccess?.();
          },
          onError: (error) => {
            onError?.(error as GlowApiError);
          },
        }
      );
    }
  };

  return {
    onResendInvitation,
    isResendingInvitation: isResendingSchoolInvitation || isResendingInvitation,
  };
}

export { useResendInvitation };
